import { render, staticRenderFns } from "./SysLogDialog.vue?vue&type=template&id=45352ba2&scoped=true"
import script from "./SysLogDialog.vue?vue&type=script&lang=js"
export * from "./SysLogDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45352ba2",
  null
  
)

export default component.exports